import React from "react";
import { useTranslation } from "react-i18next";
import InputAutoresize from "../../../../common/components/form/InputAutoresize.jsx";

const VK = "BusinessName"; // VariablesKey
export default function BusinessName(props) {
    const { t } = useTranslation();

    const { set, variables } = props;

    function onChange(event) {
        set({ ...variables, [VK]: event.target.value });
    }

    function onBlur(event) {
        set({ ...variables, [VK]: event.target.value.trim() });
    }

    return (
        <>
            <h3 className="text-left">{t("Business Name")}:</h3>
            <p className="text-left">{t("How do you call yourself")}</p>

            <InputAutoresize
                onChange={onChange}
                onBlur={onBlur}
                value={variables[VK]}
                placeholder={t("Start typing")}
                fullWidth
            />
        </>
    );
}
